import { instance } from "apis/interceptor";
import { TManager } from "apis/visitors/type";
import * as Sentry from "@sentry/react";
import { TWorkspace } from "types/user.types";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  data?: T;
};

export async function getSuperAdminList(): Promise<TManager[]> {
  try {
    const res = await instance.get("/workspaces/super-admin");
    return res.data;
  } catch (error) {
    Sentry.captureException(error);
    return [];
  }
}

export async function getAdminList(): Promise<TManager[]> {
  try {
    const res = await instance.get("/workspaces/general-admin");
    return res.data;
  } catch (error) {
    Sentry.captureException(error);
    return [];
  }
}

export async function updateMemberRole(id: string, role: string): Promise<boolean> {
  let role_number;
  switch (role) {
    case "Super Admin":
      role_number = 1;
      break;
    case "Policy Admin":
      role_number = 2;
      break;
    case "Security Admin":
      role_number = 3;
      break;
    default:
      role_number = 4;
      break;
  }

  try {
    const res = await instance.patch("/workspaces/role", {
      id: id,
      role: role_number,
    });
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: id, role: role } });
    return false;
  }
}

export async function updateWorkspaceName(name: string): Promise<boolean> {
  try {
    const res = await instance.patch("/workspaces/name", {
      name: name,
    });
    return res.data.result;
  } catch (error) {
    console.error("updateWorkspaceName", error);
    return false;
  }
}

export type TMember = {
  id: string;
  email: string;
  name: string;
  picture: string;
  isOwner: boolean;
  isAdmin: boolean;
  role: number;
  messengerConnection: string;
};

type TMembersRes = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  memberList: TMember[];
};
export async function getMembers(
  searchWord: string,
  nowPageNumber: number,
  isMessengerConnected: boolean | null,
  role: number | null
): Promise<TMembersRes | null> {
  try {
    const res = await instance.post("/workspaces/members", {
      nowPageNumber: nowPageNumber,
      isMessengerConnected: isMessengerConnected,
      role: role,
      searchWord: searchWord,
    });

    return res.data;
  } catch (error) {
    console.error("getMembers", error);
    return null;
  }
}

//UPDATE: (new) 워크스페이스 조회
export async function getWorkspaceInfo(): Promise<ResponseType<TWorkspace>> {
  try {
    const res = await instance.get("workspaces/info");
    return { success: true, data: res.data };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
        return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "권한이 없습니다." };
  }
}

//UPDATE: (new) 워크스페이스 생성
export const createWorkspace = async (name: string, image?: string) => {
  try {
    const res = await instance.post("/workspaces", {
      name: name,
      image: image,
    });

    return { success: true, member: res.data };
  } catch (error) {
    return { success: false, message: "다시 시도해주세요." };
  }
};

//UPDATE: (new) 워크스페이스 수정
export async function updateWorkspaceInfo(name: string, image: string): Promise<{result: boolean; message: string;}> {
  try {
      const res = await instance.patch(`/workspaces/info`, { name: name, image: image });
      return {result: res.data.result, message: ""};
  } catch (error: any) {
      return {result: false, message: "워크스페이스 정보 수정에 실패했습니다. 다시 시도해주세요."};
  }
}


//FEAT: (new) 워크스페이스 삭제
export const deleteWorkspace = async (): Promise<{success: boolean; statusCode?: number; message?: string;}> => {
  try {
    const res = await instance.delete("/workspaces");

    return { success: res.data.result};
  } catch (error: any) {
    const statusCode = error.response.status;

    if (statusCode === 403) {
      return { success: false, statusCode: statusCode, message: "삭제 권한이 없습니다. 권한을 확인해주세요." };
    } else if (statusCode === 427) {
      return { success: false, statusCode: statusCode, message: "잘못된 워크스페이스 접근입니다." };
    } else {
      return { success: false, statusCode: statusCode, message: "다시 시도해주세요." };
    }
  }
};
